const selectors = {
  performanceList: (state) => state.performance.performanceList.data,
  performanceVersus: (state) => state.performance.performanceVersus.data,
  fbdashboardList: (state) => state.performance.fbdashboardList.data,
  fbreportList: (state) => state.performance.fbreportList.data,
  fbgraphList: (state) => state.performance.fbgraphList.data,
  gdashboardList: (state) => state.performance.gdashboardList,
  greportList: (state) => state.performance.greportList.data,
  ggraphList: (state) => state.performance.ggraphList.data,
};

export default selectors;
